import { render, staticRenderFns } from "./ModalNewAlocation.vue?vue&type=template&id=7a6340cc&scoped=true&"
import script from "./ModalNewAlocation.vue?vue&type=script&lang=ts&"
export * from "./ModalNewAlocation.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNewAlocation.vue?vue&type=style&index=0&id=7a6340cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6340cc",
  null
  
)

export default component.exports